module.exports = __webpack_public_path__ + "img/chr_ts_90_22.dd37d2f6.png";